<template>
    <div>
        <!-- sub heading    -->
        <h4 class="contractHeading" style="float: left;">Smart Contracts (1)</h4>

        <!-- Create New NFT button -->
        <div>
            <button style="float: right; margin-top: 0;" type="button" class="btn btn-primary btn-sm action-button" v-b-modal="'new-nft-modal'" @click="clearNFTForm()">
                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="plus" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-plus">
                    <path fill="currentColor" d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z" class=""></path>
                </svg>
                <span style="padding-left: 10px;">Create New NFT</span>
            </button>
        </div>         

        <!-- main content -->
        <div>

            <!-- contracts -->
            <table class="table" style="padding-top: 30px">
                <thead>
                    <tr>
                        <th>Contract</th>
                        <th>Network</th>
                        <th>Contract Creator</th>
                        <th>Token</th>
                        <th>Token Type</th>
                        <th>Etherscan</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><div class="transactionData customLink" @click="getContractTransactions()">0x1E9014FBd5eDF15545CF2fc827778D514E5e9DD9</div></td>
                        <td>Ethereum Goerli Testnet</td>
                        <td>
                            <a href="https://goerli.etherscan.io/address/0x3c2322e7785b5ee920047e171faa7864364097c7" target="_blank">
                                <div class="transactionData customLink" style="float: left">0x3c2322E7785B5Ee920047e171Faa7864364097C7</div>
                                <div style="display: inline-block; float: left;">
                                    <font-awesome-icon style="font-size: 10px;" icon="fa-solid fa-link" />
                                </div>
                            </a>
                        </td>
                        <td>MyNFT (NFT)</td>
                        <td>ERC-721</td>
                        <td><a href="https://goerli.etherscan.io/address/0x1e9014fbd5edf15545cf2fc827778d514e5e9dd9" target="_blank">View on Etherscan <font-awesome-icon style="font-size: 10px" icon="fa-solid fa-link" /></a></td>
                    </tr>
                </tbody>
            </table>

            <!-- loading spinner -->
            <div v-if="loadingTransactions" id="nft-loading" style="margin-top: 100px;">
                <div class="lds-facebook"><div></div><div></div><div></div></div>
                <div>Connecting to Ethereum (Goerli Testnet)...</div>
            </div>     

            <!-- transactions -->
            <div v-if="showTransactions" id="transactionsList">

                <!-- transaction list -->
                <h4 class="contractSubHeading">Transactions for Contract 0x1E9014FBd5eDF15545CF2fc827778D514E5e9DD9 ({{ transactionCount }})</h4>
                <table class="table">
                    <thead>
                        <tr>
                            <th>Txn Hash</th>
                            <th>Method</th>
                            <th>Token ID</th>
                            <th>Block</th>
                            <th>Age</th>
                            <th>From</th>
                            <th>To</th>
                            <th>Etherscan</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="transaction in contractTransactions" v-bind:key="transaction.hash">
                            <!-- <td><div class="transactionData"> {{ transaction.hash }} </div></td> -->
                            <td><div class="transactionData customLink" @click="selectTransaction(transaction)">{{ transaction.hash }}</div></td>
                            <td class=""><b-badge class="customBadge" :class="transaction.badgeClass" variant="info">{{ transaction.method }}</b-badge></td>
                            <td v-if="transaction.tokenId > 0">{{ transaction.tokenId }}</td>
                            <td v-else>N/A</td>
                            <td><a v-bind:href="'https://goerli.etherscan.io/block/'+ transaction.blockNumber" target="_blank">{{ transaction.blockNumber }} <font-awesome-icon style="font-size: 10px" icon="fa-solid fa-link" /></a></td>
                            <td class="transactionData">{{ transaction.dateTime | moment("from") }}</td>
                            <td>
                                <a v-bind:href="'https://goerli.etherscan.io/address/'+ transaction.from" target="_blank">
                                    <div class="transactionData customLink" style="float: left">{{ transaction.from }}</div>
                                    <div style="display: inline-block; float: left;">
                                        <font-awesome-icon style="font-size: 10px;" icon="fa-solid fa-link" />
                                    </div>
                                </a>
                            </td>
                            <td><div class="transactionData"> {{ transaction.to }} </div></td>
                            <td><a v-bind:href="'https://goerli.etherscan.io/tx/'+ transaction.hash" target="_blank">View on Etherscan <font-awesome-icon style="font-size: 10px" icon="fa-solid fa-link" /></a></td>
                        </tr>
                    </tbody>
                </table>

                <!-- selected transaction container -->
                <div id="transactionContainer" style="position: relative;">
                    <div id="transactionContainerAnchor" style="position: absolute; top: -100px; left: 0"></div>
                    <!-- selected trasnaction  details -->
                    <div id="transactionData" v-if="showSelectedTransaction">
                        <h4 class="contractSubHeading">Transaction {{ selectedTransaction.hash }}</h4>

                        <table class="table">
                            <tbody>                             
                                <tr class="">
                                    <td>IPFS NFT Image</td>
                                    <td> 
                                        <img style="width: 200px" v-bind:src="selectedTransaction.image" />
                                        <br /><br />
                                        Image IPFS URI <a v-bind:href="selectedTransaction.image"> {{ selectedTransaction.image }}</a>
                                    </td>
                                </tr>
                                <tr class="">
                                    <td>IPFS NFT Data (JSON)</td>
                                    <td>
                                        <pre style="border: 1px solid #ababab; background-color: #f8f9fa; padding: 15px;"><s:property value="test" />{{ selectedTransaction.nft }}</pre>
                                        IPFS NFT Data URI <a :href="selectedTransaction.nft_IPFS_URI">{{ selectedTransaction.nft_IPFS_URI }}</a>                                     
                                    </td>
                                </tr> 
                                <tr class="">
                                    <td>Input Data (web3 ABI decoded)</td>
                                    <td>
                                        <pre style="border: 1px solid #ababab; background-color: #f8f9fa; padding: 15px;"><s:property value="test" />{{ selectedTransaction.result }}</pre>
                                    </td>
                                </tr>
                                <tr class="">
                                    <td>Input Data</td>
                                    <td>
                                        <div style="word-break:break-all; border: 1px solid #ababab; background-color: #f8f9fa; padding: 15px">
                                            {{ selectedTransaction.input }}
                                        </div>
                                    </td>
                                </tr>                                    
                                <tr class="hideBottomBorder">
                                    <td>Transaction Hash</td>
                                    <td><a v-bind:href="'https://goerli.etherscan.io/tx/'+ selectedTransaction.hash" target="_blank">{{ selectedTransaction.hash }} <font-awesome-icon style="font-size: 10px" icon="fa-solid fa-link" /></a></td>
                                </tr>
                                <tr class="hideBottomBorder">
                                    <td>Block</td>
                                    <td><a v-bind:href="'https://goerli.etherscan.io/block/'+ selectedTransaction.blockNumber" target="_blank">{{ selectedTransaction.blockNumber }} <font-awesome-icon style="font-size: 10px" icon="fa-solid fa-link" /></a></td>
                                </tr>
                                <tr>
                                    <td>Timestamp</td>
                                    <td>{{ selectedTransaction.dateTime | moment("from") }} ({{ selectedTransaction.dateTime }} {{ selectedTransaction.timeStamp }})</td>
                                </tr>
                                <tr class="hideBottomBorder">
                                    <td>From</td>
                                    <td><a v-bind:href="'https://goerli.etherscan.io/address/'+ selectedTransaction.from" target="_blank">{{ selectedTransaction.from }} <font-awesome-icon style="font-size: 10px" icon="fa-solid fa-link" /></a></td>
                                </tr>
                                <tr>
                                    <td style="white-space: nowrap;">Interacted With (To):</td>
                                    <td v-if="!selectedTransaction.isContract"><a v-bind:href="'https://goerli.etherscan.io/address/'+ selectedTransaction.to" target="_blank">{{ selectedTransaction.to }} <font-awesome-icon style="font-size: 10px" icon="fa-solid fa-link" /></a></td>
                                    <td v-else> {{ selectedTransaction.to}} </td>
                                </tr>                    
                                <tr v-if="!selectedTransaction.isContract">
                                    <td>Tokens Transferred:</td>
                                    <td>
                                        <b>From</b> 0x0000000000000000000000000000000000000000 <b>To </b><a v-bind:href="'https://goerli.etherscan.io/token/0x1e9014fbd5edf15545cf2fc827778d514e5e9dd9?a='+ selectedTransaction.from" target="_blank">{{ selectedTransaction.from }} <font-awesome-icon style="font-size: 10px" icon="fa-solid fa-link" /></a><br />
                                        For ERC-721 Token ID [<a v-bind:href="'https://goerli.etherscan.io/token/0x1E9014FBd5eDF15545CF2fc827778D514E5e9DD9?a='+ selectedTransaction.tokenId" target="_blank">{{ selectedTransaction.tokenId }} <font-awesome-icon style="font-size: 10px" icon="fa-solid fa-link" /></a>] MyNFT (NFT)
                                    </td>
                                </tr>       
                                <tr>
                                    <td>Value</td>
                                    <td>{{ selectedTransaction.value }} ETH</td>
                                </tr>
                                <tr>
                                    <td>Gas Price</td>
                                    <td>{{ selectedTransaction.gasPriceEther }} Ether ({{ selectedTransaction.gasPriceGwei }} Gwei)</td>
                                </tr>
                                <tr>
                                    <td>transactionIndex</td>
                                    <td>{{ selectedTransaction.transactionIndex }}</td>
                                </tr>
                                <tr>
                                    <td>gas</td>
                                    <td>{{ selectedTransaction.gas }}</td>
                                </tr>
                                <tr>
                                    <td>contractAddress</td>
                                    <td>{{ selectedTransaction.contractAddress }}</td>
                                </tr>
                                <tr>
                                    <td>cumulativeGasUsed</td>
                                    <td>{{ selectedTransaction.cumulativeGasUsed }}</td>
                                </tr>
                                <tr>
                                    <td>txreceipt_status</td>
                                    <td>{{ selectedTransaction.txreceipt_status }}</td>
                                </tr>
                                <tr>
                                    <td>gasUsed</td>
                                    <td>{{ selectedTransaction.gasUsed }}</td>
                                </tr>
                                <tr>
                                    <td>confirmations</td>
                                    <td>{{ selectedTransaction.confirmations }}</td>
                                </tr>
                                <tr>
                                    <td>isError</td>
                                    <td>{{ selectedTransaction.isError }}</td>
                                </tr>
                                <tr>
                                    <td>input (need to use web3.toAscii(transactionID.input))</td>
                                    <td style="word-break:break-all">{{ selectedTransaction.input }}</td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                
                </div>
                
            </div>

        </div>

        <!-- new NFT modal -->
        <b-modal id="new-nft-modal" size="md" title="Create New NFT">

            <!-- ID -->
            <div style="float: left; width: 100%;">
                <b-form-group id="input-group-2" style="float: left; width: 100%;" label="ID:" label-for="input-2">
                    <b-form-input id="input-2" v-model="NFT.ID" placeholder="" size="sm"></b-form-input>
                </b-form-group>
            </div>

            <!-- S3 image upload -->
            <div style="float: left; width: 100%;">
                <hr />
                <b-form-group id="input-group-2" label="NFT Image:" label-for="input-2">
                    <input type="file" style="float: left;" accept="image/jpeg,image/png,.pdf" @change=set_file>
                    <b-button size="sm" style="float: right;" variant="primary" :disabled="creating_nft" @click="s3ImageUpload()">
                        <span v-if="creating_nft" class="spinner-border spinner-border-sm" style="margin-right: 10px;" role="status" aria-hidden="true"></span> 
                        <span>Create NFT</span>
                    </b-button>
                </b-form-group>        
            </div>
            
                <!-- NFT Details -->            
            <div style="float: left; width: 100%;">
                <img style="width: 100px;" :src="NFT.image" />
                <hr />            
                <div>
                    <b-form-group id="input-group-2" label="Name:" label-for="input-2">
                        <b-form-input id="input-2" v-model="NFT.name" placeholder="" size="sm"></b-form-input>
                    </b-form-group>

                    <b-form-group id="input-group-2" label="Description:" label-for="input-2">
                        <b-form-input id="input-2" v-model="NFT.description" placeholder="" size="sm"></b-form-input>
                    </b-form-group>

                    <b-form-group id="input-group-2" label="Image (URL):" label-for="input-2">
                        <b-form-input id="input-2" v-model="NFT.image" disabled placeholder="" size="sm"></b-form-input>
                    </b-form-group>

                    <b-form-group id="input-group-2" label="QR Hash:" label-for="input-2">
                        <b-form-input id="input-2" v-model="NFT.qr_hash" placeholder="" size="sm"></b-form-input>
                    </b-form-group>

                    <b-form-group id="input-group-2" label="User:" label-for="input-2">
                        <b-form-input id="input-2" v-model="NFT.user" placeholder="" size="sm"></b-form-input>
                    </b-form-group>

                    <b-form-group id="input-group-2" label="Other:" label-for="input-2">
                        <b-form-input id="input-2" v-model="NFT.other" placeholder="" size="sm"></b-form-input>
                    </b-form-group>
                </div>
            </div> 

            <!-- s3 JSON upload -->
            <div style="float: left; width: 100%;">
                <!-- <b-button size="sm" style="float: right;" variant="primary" :disabled="uploading_json" @click="s3JSONDataUpload()">
                    <span v-if="uploading_json" class="spinner-border spinner-border-sm" style="margin-right: 10px;" role="status" aria-hidden="true"></span> 
                    <span>Upload</span>
                </b-button> -->
            </div>
            
            <!-- NFT Token URI -->
            <div style="float: left; width: 100%;">
                <hr />
                <div>
                    <b-form-group id="input-group-2" label="NFT Token URI:" label-for="input-2">
                        <b-form-input id="input-2" v-model="tokenURI" disabled placeholder="" size="sm"></b-form-input>
                    </b-form-group>
                </div>
            </div>

            <!-- mint result -->
            <div style="float: left; width: 100%; overflow: scroll">
                <table class="">
                    <tr>
                        <td style="padding-right: 10px;"><b>blockHash</b></td>
                        <td>{{ mintResult.blockHash }}</td>
                    </tr>
                    <tr>
                        <td style="padding-right: 10px;"><b>blockNumber</b></td>
                        <td>{{ mintResult.blockNumber }}</td>
                    </tr>
                    <tr>
                        <td style="padding-right: 10px;"><b>from</b></td>
                        <td>{{ mintResult.from }}</td>
                    </tr>
                    <tr>
                        <td style="padding-right: 10px;"><b>gasUsed</b></td>
                        <td>{{ mintResult.gasUsed }}</td>
                    </tr>
                    <tr>
                        <td style="padding-right: 10px;"><b>to</b></td>
                        <td>{{ mintResult.to }}</td>
                    </tr>            
                    <tr>
                        <td style="padding-right: 10px;"><b>transactionHash</b></td>
                        <td>{{ mintResult.transactionHash }}</td>
                    </tr>                                                                       
                </table>
            </div>


            <!-- model footer -->
            <template #modal-footer>
                <b-button size="sm" variant="secondary" :disabled="creating_nft" @click="closeModal()">
                    Close
                </b-button>                    
                <!-- <b-button size="sm" variant="primary" :disabled="creating_nft" @click="createNFT()">
                    <span v-if=" creating_nft" class="spinner-border spinner-border-sm" style="margin-right: 10px;" role="status" aria-hidden="true"></span> 
                    <span>Create NFT</span>
                </b-button> -->
            </template>
        </b-modal>        

    </div>
</template>

<script>
    import moment from 'moment'
    //import { web3 } from 'web3'
    import abi from './abi.json'
    import AWS from 'aws-sdk';

    export default {
        name: 'nft',
        data: function () {
            return {
                temp: "Ethereum component loaded 👍",
                contractTransactions:'',
                showTransactions: false,
                showSelectedTransaction: false,
                selectedTransaction: null,
                transactionCount: 0,
                loadingTransactions: false,
                NFT: {
                    ID: null,
                    name: null,
                    description: null,
                    image: null,
                    qr_hash: null,
                    user: null,
                    other: null,
                },
                tokenURI: null,
                uploading_image: false,
                uploading_json: false,
                creating_nft: false,
                previewFileURL: null,
                fileToUpload: null,
                imageData: null,
                mintResult: {
                    blockHash: null,
                    blockNumber: null,
                    from: null,
                    gasUsed: null,
                    to: null,
                    transactionHash: null,
                },      
            };
        },
        props: [],
        watch: {
            showTransactions(newValue) {
                localStorage.showTransactions = newValue;
                this.showSelectedTransaction = false;
                console.log("UPDATE - localStorage.showTransactions = " + localStorage.showTransactions);
        }
        },
        methods: {
            set_file(e) {
                const file = e.target.files[0];
                this.previewFileURL = URL.createObjectURL(file);
                this.fileToUpload = file;
            },
            clearNFTForm() {
                // clear form
                this.NFT.ID = null;
                this.NFT.name = null;
                this.NFT.description = null;
                this.NFT.image = null;
                this.NFT.qr_hash = null;
                this.NFT.user = null;
                this.NFT.other = null;
                this.imageData = null;
                this.tokenURI = null;
                this.mintResult.blockHash = null;
                this.mintResult.blockNumber = null;
                this.mintResult.from = null;
                this.mintResult.gasUsed = null;
                this.mintResult.to = null;
                this.mintResult.transactionHash = null;
            },
            async s3ImageUpload() {
                this.creating_nft = true;

                this.uploading_image = true;
                console.log("this.previewFileURL = " + this.previewFileURL);
                console.log("this.fileToUpload = " + this.fileToUpload);

                var bucket = 'lc-token-testing';
                var filename = this.fileToUpload.name;
                console.log(this.fileToUpload.name);

                // override filename with ID
                var extention = filename.split('.')[1];
                filename = this.NFT.ID + '.' + extention;

                var upload = new AWS.S3.ManagedUpload({
                    params: {
                        Bucket: bucket,
                        Key: filename,
                        Body: this.fileToUpload,
                        ACL: "public-read",
                        'Content-Type': 'image/png'
                    }
                });

                var promise = await upload.promise();
                this.imageData = promise;
                console.log(this.imageData.Location);
                this.NFT.image = this.imageData.Location;
                this.uploading_image = false;

                // automatically set values for the rest of the NFT properties
                this.NFT.name = this.NFT.ID
                this.NFT.description = "desc";
                this.NFT.qr_hash = "qr";
                this.NFT.user = "1";
                this.NFT.other = "other";

                // s3 json upload
                this.s3JSONDataUpload();
            },
            async s3JSONDataUpload() {
                this.uploading_json = true;
                var JSONData = {
                    name: this.NFT.name,
                    description: this.NFT.description,
                    image: this.NFT.image,
                    qr_hash: this.NFT.name,
                    user: this.NFT.name,
                    other: this.NFT.other
                }

                var buf = Buffer.from(JSON.stringify(JSONData));
                console.log(buf);

                var bucket = 'lc-token-testing';
                var filename = this.NFT.image.split("/")[3].split(".")[0] + ".json";
                console.log(filename);

                var upload = new AWS.S3.ManagedUpload({
                    params: {
                        Bucket: bucket,
                        Key: filename,
                        Body: buf,
                        ACL: "public-read",
                        'Content-Type': 'application/json'
                    }
                });

                var promise = await upload.promise();
                this.jsonData = promise;
                console.log(this.jsonData.Location);
                this.tokenURI = this.jsonData.Location;
          
                this.uploading_json = false;

                // min NFT
                this.createNFT();
            },
            async createNFT() {
                this.creating_nft = true;
                console.log("create NFT clicked!");
                console.log("tokenURI = " + this.tokenURI);

                try {
                    let url = process.env.VUE_APP_NFT_API_URI;
                    let headers = {
                        'Content-Type': 'application/json;charset=utf-8',
                        'authorization': localStorage.idtoken
                    };
                    let data = {
                        "api":"createNFT",
                        "path": this.tokenURI
                    };
                    data = JSON.stringify(data);

                    const response = await this.$http.post(
                        url,
                        data,
                        {headers: headers}
                    );

                    console.log(response.data);

                    this.mintResult = response.data;

                    this.creating_nft = false;
                    //this.closeModal();

                } catch (error) {
                    console.log(error);
                }                    

            },
            closeModal: function() {
                console.log("close modal");
                this.$root.$emit('bv::hide::modal', 'new-nft-modal', '#btnShow')
            },
            async getContractTransactions() {
                this.loadingTransactions = true;
                this.showSelectedTransaction = false;

                // api call variables
                var module = "account";
                var action = "txlist";
                var address = "0x1E9014FBd5eDF15545CF2fc827778D514E5e9DD9";
                var startblock = "0";
                var endblock = "99999999";
                var page = "1";
                var offset = "200"; // return results per page
                var sort = "asc";
                var apikey = "PUPIQHT1U92DWYG2J91A36R56B8CW7D76U";

                // ethereum-input-data-decoder test (once working change to use web3)
                const InputDataDecoder = require('ethereum-input-data-decoder');
                const decoder = new InputDataDecoder(abi);                

                try {
                    const response = await this.$http.get(
                        "https://api-goerli.etherscan.io/api?" 
                        + "module=" + module +"&" 
                        + "action=" + action +"&" 
                        + "address=" + address + "&"
                        + "startblock=" + startblock + "&" 
                        + "endblock=" + endblock + "&" 
                        + "page=" + page + "&" 
                        + "offset=" + offset + "&" 
                        + "sort=" + sort + "&" 
                        + "apikey=" + apikey
                    );
                    this.contractTransactions = response.data.result;

                    var transactionCount = 0;
                    var tokenId = 0;

                    for(var i = 0; i < this.contractTransactions.length; i++) {
                        this.contractTransactions[i].image = "";
                        console.log(i);
                        console.log(this.contractTransactions[i].timeStamp);
                        console.log(moment.unix(this.contractTransactions[i].timeStamp).toDate());

                        this.contractTransactions[i].dateTime = moment.unix(this.contractTransactions[i].timeStamp).toDate();

                        // find and Contract Creation transaction
                        if(this.contractTransactions[i].to.length === 0) {
                            this.contractTransactions[i].to = "Contract Creation";
                            //this.contractTransactions[i].method = "0x60806040";
                            this.contractTransactions[i].method = "Contract Created";
                            this.contractTransactions[i].isContract = true;
                            this.contractTransactions[i].badgeClass = "created_badge";
                        } else {
                            this.contractTransactions[i].isContract = false;
                            if(this.contractTransactions[i].input.slice(0, 10) == "0xeacabe14") {
                                this.contractTransactions[i].method = "Mint NFT";
                                this.contractTransactions[i].badgeClass = "mint_badge";
                                tokenId++;

                                // decode input data
                                var result = decoder.decodeData(this.contractTransactions[i].input);

                                this.contractTransactions[i].result = result;

                                var nft_IPFS_URI = result.inputs[1];
                                console.log(nft_IPFS_URI);

                                this.contractTransactions[i].nft_IPFS_URI = nft_IPFS_URI;
                                
                                // get NFT
                                var nftUrl = this.contractTransactions[i].nft_IPFS_URI.split("/");
                                console.log(nftUrl[3]);
                                var nftPath = nftUrl[3];

                                try {
                                    let url = process.env.VUE_APP_NFT_API_URI;
                                    let headers = {
                                        'Content-Type': 'application/json;charset=utf-8',
                                        'authorization': localStorage.idtoken
                                    };
                                    let data = {
                                        "api":"fetchNFT",
                                        "path":"/" + nftPath
                                    };
                                    data = JSON.stringify(data);

                                    const response = await this.$http.post(
                                        url,
                                        data,
                                        {headers: headers}
                                    );

                                    console.log(response.data);

                                    //this.nft = response.data;
                                    this.contractTransactions[i].nft = response.data;
                                    this.contractTransactions[i].image = response.data.image;

                                } catch (error) {
                                    console.log(error);
                                }                                    


                            } else {
                                this.contractTransactions[i].method = "Transfer From";
                                this.contractTransactions[i].badgeClass = "transfer_badge";
                            }
                        }

                        //gas price conversions
                        this.contractTransactions[i].gasPriceeWei = parseInt(this.contractTransactions[i].gasPrice);
                        this.contractTransactions[i].gasPriceGwei = this.contractTransactions[i].gasPriceeWei / 1000000000;
                        this.contractTransactions[i].gasPriceEther = this.contractTransactions[i].gasPriceeWei / 1000000000000000000;

                        this.contractTransactions[i].gasPriceEtherString = this.contractTransactions[i].gasPriceEther.toString();

                        this.contractTransactions[i].tokenId = tokenId;
                        transactionCount++;
                    }

                    this.contractTransactions.splice(1, 2);
                    this.contractTransactions.splice(3, 1);
                    
                    this.transactionCount = transactionCount;

                    // reverse
                    this.contractTransactions.reverse();

                    console.log(this.contractTransactions);

                    this.showTransactions = true;

                    this.loadingTransactions = false;
                    document.getElementById("transactionsList").style.display = 'block';
                } catch (error) {
                    console.log(error);
                }
            },
            selectTransaction: function(transaction) {
                console.log("selectTransaction clicked!");
                this.selectedTransaction = transaction;
                console.log("selectTransaction = " + this.selectedTransaction);
                this.showSelectedTransaction = true;

                // smooth scroll to selected transaction                
                setTimeout(function() {
                    var element = document.getElementById("transactionContainerAnchor"); 
                    element.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});  
                }, 500);                
            },
        },
        mounted: function () {

        }
    }
</script>

<style>
    .created_badge {
        background-color: #F2E9CC !important;
    }

    .mint_badge {
        background-color: #C2D5A8 !important;
    }

    .transfer_badge {
        background-color: #BAD5F0 !important;
    }

    .hideBottomBorder {
        border-bottom: 1px #fff !important;
    }

    .customBadge {
        background-color: #3498db1a;
        color: #000 !important;
        font-weight: 400 !important;
        height: 100%;
        width: 100%;        
    }

    .customLink {
        color: #0d6efd;
        text-decoration: underline;
        cursor: pointer;
    }

    .customLink:hover {
        color: #0a58ca;
    }    

    .contractHeading {
        padding-bottom: 30px;
    }

    .contractSubHeading {
        padding-bottom: 30px;
        padding-top: 30px;
    }    

    div.transactionData {
        white-space: nowrap; 
        width: 100px; 
        overflow: hidden;
        text-overflow: ellipsis;
        display: inline-block;
    }

</style>    

